<template>
  <v-container >
    <v-card width="500" height="auto" class="elevation-7 mx-auto text-center mt-1 pa-2 rounded-lg">
        <v-form style="width: 100% ">
          <div class="mx-auto pa-2">
            <div class="cd-info">{{preUser_ID}}</div>

            <div class="flex">
              <v-text-field dense outlined 
                class="textfield"
                :loading = "loadingName"
                id="name" 
                ref="name" 
                label="성명✽" 
                v-model="name" 
              />
              <v-combobox dense outlined
                class="selectmin"
                id="duty" 
                ref="duty"
                label="직책✽" 
                placeholder="항목이 없으면 직접 입력하세요"
                :items="['대표','이사','본부장','농장/사업장장','부장','과장','대리','사원','기타']"
                :menu-props="{ top: false, offsetY: true }"
                v-model="duty"
                clearable 
              />
              <v-text-field dense outlined
                class="textfield"
                id="phone" 
                ref="phone" 
                label="연락처✽" 
                placeholder="숫자만 입력"
                v-model="phone"
                @keyup="getPhoneMask(phone)"
              />
            </div>

            <div class="flex mt-2 ml-2 mt-3">
              <span>알림수신✽</span>
              <div style="margin-top:-20px;">
                <v-radio-group dense outlined row 
                  id="call_YN" 
                  v-model="call_YN"
                >
                    <v-radio ref="call_y" style="margin-left: 16px;" label="동의" value="Y" color="#005B96" ></v-radio>
                    <v-radio label="거부" value="N" color="red"></v-radio>
                </v-radio-group>
              </div>
            </div>            
          
            <div class="flex">
              <v-text-field dense outlined
                class="textfield"
                id="email_id" 
                ref="email_id" 
                label="이메일" 
                v-model="email_id" 
              />
              <div class="mt-3 ml-1 mr-1">@</div>
              <v-combobox dense outlined 
                id="email_host" 
                ref="email_host" 
                :items="['gmail.com','hotmail.com','naver.com','daum.net',]"
                :menu-props="{ top: false, offsetY: true }"
                placeholder="항목이 없으면 직접 입력하세요"
                v-model="email_host" 
              />
            </div>

            <div class="mt-2 flex vertical-center">
              <button  v-if="this.$getters.userName !== '방문고객'" class="rounded-pill elevation-7 normal-btn" style="margin: 10px;" 
                :loading="loading"
                id="save" 
                ref="save" 
                type="submit" 
                @click.prevent="save()"
              >
                저장
              </button>
              <button class="rounded-pill elevation-7 new-btn" 
                id="cancel" 
                ref="cancel" 
                @click="cancel()">
                취소
              </button>
            </div>
          </div>
        </v-form>    
    </v-card>
  </v-container>
</template>

<script>
import Apis from '@/api/apis'
import Common from "@/utils/custom/common.js";
import VueCookies from "vue-cookies";

export default {
  name: 'ChangeMyInfo',

  data: () => ({
    preUser_ID: "",
    name: "",
    phone: "",
    call_YN: "",
    duty: "",
    email_id: "",
    email_host: "",
    loadingName: false,
    loading: false,
  }),

  mounted() {
    this.accountInfo();
    this.$refs.name.focus();
  },

  methods: {
    clearData() {
      this.preUser_ID = "";
      this.name = "";
      this.phone = "";
      this.call_YN = "";
      this.duty = "";
      this.email_id = "";
      this.email_host = "";
      this.loadingName = false;
      this.loadingSave = false;
    }, 
    checkData() {
      if (!this.name.trim()) {
        this.$refs.name.focus();
        return "성명을 입력하세요";
      }
      if (!this.phone.trim()) {
        this.$refs.phone.focus();
        return "연락처를 입력하세요";
      }
      if (!this.call_YN) {
        this.$refs.call_y.$el.children[1].focus()
        return "알림 동의 여부를 선택하세요";
      }
      if (!this.duty) {
        this.$refs.duty.focus();
        return "직책을 선택 입력하세요";
      }
      return "";
    },
    accountInfo() {             // todo 개인 조회시 관할 농장/사업장리스트, 입사일 항목 추가
      this.$store.commit("resMessage","");
      this.loadingName = true;
      this.clearData();
      Apis.infoUser({
        account: VueCookies.get("account"), 
        },(res) => {  
          if (res.result) {
            // console.log("DATA",res.data);
            this.preUser_ID = res.data.account,
            this.name = res.data.user_name; 
            this.duty = res.data.duty;	
            let email = res.data.email1.split("@",2);
            this.email_id = email[0];
            this.email_host = email[1];
            this.phone = Common.getMask(res.data.phone1);
            this.call_YN = res.data.call_yn; 
            this.loadingNmae = false;
            this.$store.commit("resMessage",res.message);
          } else {
            alert(res.message);
            this.loadingName = false;
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류",err)
            this.loadingName = false;
            alert(err);
        }
      ); 
    },
    save() {
      this.$store.commit("resMessage","");
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        return;
      }
      this.loadingSave = true;
      Apis.updateUserFree({
        account: this.preUser_ID,
        user_name : this.name.trim(),
        duty:	this.duty,
        email1:	this.email_id.trim() + "@" + this.email_host,
        phone1:	this.phone.replace(/[^0-9]/g, ''),
        call_yn: this.call_YN,
        },(res) => {  
          if (res.result) {
            this.$store.commit("resMessage",res.message);
            this.loadingSave = false;
          } else {
            this.loadingSave = false;
            this.$refs.user_ID.focus();
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            this.loadingSave = false;
            console.log(" updateUserFree API 호출 오류",err)
            alert(err);
        }
      )
     
    },
    cancel() {
      this.$router.go(-1);
    },

    getPhoneMask(val) {
      this.phone = Common.getMask(val)
    },

  }  // -----------methods 

}
// 01-06
</script>

<style lang="scss" scoped>
@import './info_style.scss';

.normal-btn{
  // color:#005B96 !important;
  font-size:12pt !important;
  font-weight: bold !important;
  background-color: rgb(248, 248, 248) !important;
  background-color:#005B96 !important;
  color:white;
}
.new-btn{
  color:#005B96 !important;
  font-size:12pt !important;
  font-weight: bold !important;
  background-color: rgb(248, 248, 248) !important;
}
.confirm_btn{
  color:white !important;
  font-size:12pt !important;
  font-weight: bold !important;
  background-color: #88191a !important;
}
</style>
